<template>
  <span>
    <div v-b-popover.hover.topright.html="getSpan( data.item.certificate_name_en , 'certificate' )">
      <span style="font-size: smaller;">
        {{ getSmallName(data.item.certificate_name_en) }}
      </span>
    </div>

  </span>
</template>

<script>
export default {
  name: 'CertificateCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    getSmallName: {
      type: Function,
      required: true,
    },
    getSpan: {
      type: Function,
      required: true,
    },
  },
}
</script>
